import { render, staticRenderFns } from "./tripAdd.vue?vue&type=template&id=33a201ac&scoped=true&"
import script from "./tripAdd.vue?vue&type=script&lang=js&"
export * from "./tripAdd.vue?vue&type=script&lang=js&"
import style0 from "./tripAdd.vue?vue&type=style&index=0&id=33a201ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a201ac",
  null
  
)

export default component.exports